"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Questionnaire = Questionnaire;
exports.QuestionnaireActions = QuestionnaireActions;
exports.QuestionnaireChoice = QuestionnaireChoice;
exports.QuestionnaireChoiceDescription = QuestionnaireChoiceDescription;
exports.QuestionnaireChoices = QuestionnaireChoices;
exports.QuestionnaireDescription = QuestionnaireDescription;
exports.QuestionnaireError = QuestionnaireError;
exports.QuestionnaireInput = QuestionnaireInput;
exports.QuestionnaireItem = QuestionnaireItem;
exports.QuestionnaireNext = QuestionnaireNext;
exports.QuestionnairePrevious = QuestionnairePrevious;
exports.QuestionnaireProgress = QuestionnaireProgress;
exports.QuestionnaireSkip = QuestionnaireSkip;
exports.QuestionnaireSubmit = QuestionnaireSubmit;
exports.QuestionnaireTitle = QuestionnaireTitle;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@design/lib/utils");
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["children", "className", "type", "shortcut"],
  _excluded8 = ["className"],
  _excluded9 = ["className"],
  _excluded0 = ["className"],
  _excluded1 = ["className"],
  _excluded10 = ["children", "className"],
  _excluded11 = ["children", "className"],
  _excluded12 = ["children", "className"],
  _excluded13 = ["children", "className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function Questionnaire(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "questionnaire",
    className: (0, _utils.cn)("flex w-full min-w-0 flex-col gap-6", className)
  }, props), {}, {
    "data-sentry-component": "Questionnaire",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnaireProgress(_ref2) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "questionnaire-progress",
    className: (0, _utils.cn)("min-h-[1lh] w-fit min-w-[14ch] text-xs font-medium text-muted-foreground tabular-nums", className)
  }, props), {}, {
    "data-sentry-component": "QuestionnaireProgress",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnaireItem(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("fieldset", _objectSpread(_objectSpread({
    "data-slot": "questionnaire-item",
    className: (0, _utils.cn)("flex min-w-0 flex-col gap-2 border-0 p-0 outline-none", className)
  }, props), {}, {
    "data-sentry-component": "QuestionnaireItem",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnaireTitle(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("legend", _objectSpread(_objectSpread({
    "data-slot": "questionnaire-title",
    className: (0, _utils.cn)("cn-font-heading mb-2 text-body font-medium text-pretty", className)
  }, props), {}, {
    "data-sentry-component": "QuestionnaireTitle",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnaireDescription(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", _objectSpread(_objectSpread({
    "data-slot": "questionnaire-description",
    className: (0, _utils.cn)("text-caption text-pretty text-muted-foreground", className)
  }, props), {}, {
    "data-sentry-component": "QuestionnaireDescription",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnaireChoices(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "questionnaire-choices",
    className: (0, _utils.cn)("group/questionnaire-choices grid min-w-0 gap-1 py-2", className)
  }, props), {}, {
    "data-sentry-component": "QuestionnaireChoices",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnaireChoice(_ref7) {
  var children = _ref7.children,
    className = _ref7.className,
    type = _ref7.type,
    shortcut = _ref7.shortcut,
    props = _objectWithoutProperties(_ref7, _excluded7);
  var indicator = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "aria-hidden": "true",
    "data-slot": "questionnaire-choice-indicator",
    className: "pointer-events-none relative flex size-4 shrink-0 translate-y-[--spacing(0.45)] items-center justify-center rounded-[4px] border border-input group-has-data-[slot=questionnaire-choice-description]/questionnaire-choice:translate-y-0.5 group-data-[type=radio]/questionnaire-choice:rounded-full group-has-[>input:checked]/questionnaire-choice:border-primary group-has-[>input:checked]/questionnaire-choice:bg-primary group-has-[>input:checked]/questionnaire-choice:text-primary-foreground dark:bg-input/30 dark:group-has-[>input:checked]/questionnaire-choice:bg-primary",
    children: type === "radio" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "data-slot": "questionnaire-choice-indicator-dot",
      className: "hidden size-2 rounded-full bg-primary-foreground group-has-[>input:checked]/questionnaire-choice:block"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
      "data-slot": "questionnaire-choice-indicator-check",
      className: "hidden size-3.5 group-has-[>input:checked]/questionnaire-choice:block"
    })
  });
  var shortcutKey = /*#__PURE__*/(0, _jsxRuntime.jsx)("kbd", {
    "data-slot": "questionnaire-choice-shortcut",
    className: "pointer-events-none ms-auto hidden size-5 shrink-0 translate-y-[--spacing(0.45)] items-center justify-center rounded-md border border-input bg-background font-mono text-[0.625rem] leading-none font-medium text-muted-foreground shadow-xs group-has-data-[slot=questionnaire-choice-description]/questionnaire-choice:translate-y-0.5 group-data-[shortcut]/questionnaire-choice:inline-flex",
    children: shortcut
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    "data-slot": "questionnaire-choice",
    "data-type": type,
    "data-shortcut": shortcut,
    className: (0, _utils.cn)("group/questionnaire-choice relative flex min-h-11 cursor-pointer items-start gap-3.5 rounded-lg border border-input bg-transparent px-4 py-3.5 text-start text-sm shadow-xs transition-colors outline-none select-none hover:bg-muted/50 has-[>input:focus-visible]:border-ring has-[>input:focus-visible]:ring-3 has-[>input:focus-visible]:ring-ring/50 has-[>input[aria-invalid=true]]:border-destructive has-[>input:checked]:card-selected", "has-[>input:disabled]:pointer-events-none has-[>input:disabled]:cursor-not-allowed has-[>input:disabled]:opacity-50", className),
    "data-sentry-component": "QuestionnaireChoice",
    "data-sentry-source-file": "questionnaire.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({
      "data-slot": "questionnaire-choice-input",
      type: type,
      className: "absolute inset-0 z-10 size-full cursor-pointer opacity-0"
    }, props)), indicator, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "data-slot": "questionnaire-choice-label",
      className: "flex min-w-0 flex-1 flex-col gap-1 leading-snug",
      children: children
    }), shortcutKey]
  });
}
function QuestionnaireChoiceDescription(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
    "data-slot": "questionnaire-choice-description",
    className: (0, _utils.cn)("text-muted-foreground", className)
  }, props), {}, {
    "data-sentry-component": "QuestionnaireChoiceDescription",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnaireInput(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-slot": "questionnaire-input-wrapper",
    className: "group/questionnaire-input relative w-full min-w-0",
    "data-sentry-component": "QuestionnaireInput",
    "data-sentry-source-file": "questionnaire.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({
      "data-slot": "questionnaire-input",
      className: (0, _utils.cn)("h-9 min-h-11 w-full min-w-0 rounded-md border border-input bg-transparent px-2.5 py-1 text-base shadow-xs transition-[color,box-shadow,background-color] outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 sm:min-h-0 md:text-sm dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", "selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground", className)
    }, props))
  });
}
function QuestionnaireError(_ref0) {
  var className = _ref0.className,
    props = _objectWithoutProperties(_ref0, _excluded0);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", _objectSpread(_objectSpread({
    role: "alert",
    "data-slot": "questionnaire-error",
    className: (0, _utils.cn)("text-sm text-destructive", className)
  }, props), {}, {
    "data-sentry-component": "QuestionnaireError",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnaireActions(_ref1) {
  var className = _ref1.className,
    props = _objectWithoutProperties(_ref1, _excluded1);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "questionnaire-actions",
    className: (0, _utils.cn)("grid min-h-11 w-full grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-2 sm:min-h-9", className)
  }, props), {}, {
    "data-sentry-component": "QuestionnaireActions",
    "data-sentry-source-file": "questionnaire.tsx"
  }));
}
function QuestionnairePrevious(_ref10) {
  var _ref10$children = _ref10.children,
    children = _ref10$children === void 0 ? "Previous" : _ref10$children,
    className = _ref10.className,
    props = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
    type: "button",
    "data-slot": "questionnaire-previous",
    variant: "outline",
    className: (0, _utils.cn)("col-start-1 row-start-1 min-h-11 justify-self-start sm:min-h-0", className)
  }, props), {}, {
    "data-sentry-element": "Button",
    "data-sentry-component": "QuestionnairePrevious",
    "data-sentry-source-file": "questionnaire.tsx",
    children: children
  }));
}
function QuestionnaireSkip(_ref11) {
  var _ref11$children = _ref11.children,
    children = _ref11$children === void 0 ? "Skip" : _ref11$children,
    className = _ref11.className,
    props = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
    type: "button",
    "data-slot": "questionnaire-skip",
    variant: "outline",
    className: (0, _utils.cn)("col-start-2 row-start-1 min-h-11 justify-self-end sm:min-h-0", className)
  }, props), {}, {
    "data-sentry-element": "Button",
    "data-sentry-component": "QuestionnaireSkip",
    "data-sentry-source-file": "questionnaire.tsx",
    children: children
  }));
}
function QuestionnaireNext(_ref12) {
  var _ref12$children = _ref12.children,
    children = _ref12$children === void 0 ? "Next" : _ref12$children,
    className = _ref12.className,
    props = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
    type: "button",
    "data-slot": "questionnaire-next",
    className: (0, _utils.cn)("col-start-3 row-start-1 min-h-11 justify-self-end sm:min-h-0", className)
  }, props), {}, {
    "data-sentry-element": "Button",
    "data-sentry-component": "QuestionnaireNext",
    "data-sentry-source-file": "questionnaire.tsx",
    children: children
  }));
}
function QuestionnaireSubmit(_ref13) {
  var _ref13$children = _ref13.children,
    children = _ref13$children === void 0 ? "Submit" : _ref13$children,
    className = _ref13.className,
    props = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
    type: "submit",
    "data-slot": "questionnaire-submit",
    className: (0, _utils.cn)("col-start-3 row-start-1 min-h-11 justify-self-end sm:min-h-0", className)
  }, props), {}, {
    "data-sentry-element": "Button",
    "data-sentry-component": "QuestionnaireSubmit",
    "data-sentry-source-file": "questionnaire.tsx",
    children: children
  }));
}